export default __webpack_public_path__ + "static/media/CRM-2.95267a6e.png";